import { Helmet } from 'react-helmet-async';
import CategoryPageTemplate from '../components/CategoryPageTemplate';
import { DHOOP_CONE } from '../data/products';

const heroImg = "/images/abouthero.webp";

const DHOOP_CONE_TIERS = [
  { id: "Premium",       label: "Premium",      icon: "⭐", desc: "Elevated experience", badge: "LATEST" },
  { id: "Extra Premium", label: "Extra Premium", icon: "💎", desc: "Luxury & gifting",    badge: "NEW" },
  { id: "All",           label: "All Products",  icon: "✦", desc: "",                    badge: null },
];

export default function DhoopConePage() {
  return (
    <>
      <Helmet>
        <title>Buy Dhoop Cones Online | Premium Masala Dhoop Cone — Prakhyat</title>
        <meta
          name="description"
          content="Shop Prakhyat Dhoop Cones online — Premium & Extra Premium Masala Dhoop Cones in Sandalwood, Guggal, Rose, Amber & more fragrances. 100% natural ingredients. Ideal for Pooja, Meditation, Yoga & Temple use."
        />
        <meta
          name="keywords"
          content="buy dhoop cone online, premium dhoop cone, masala dhoop cone, sandalwood dhoop cone, guggal dhoop cone, rose dhoop cone, amber dhoop cone, natural dhoop cone india, pooja dhoop cone, temple dhoop cone, prakhyat dhoop cone, extra premium dhoop cone, dhoop cone meditation"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://prakhyatagarbatti.com/products/dhoop-cone" />
      </Helmet>

      <CategoryPageTemplate
        title="Dhoop Cone Collection"
        subtitle="Dense, rich fragrance in every cone — pure natural ingredients, powerful spiritual presence"
        products={DHOOP_CONE}
        heroBg={heroImg}
        tiers={DHOOP_CONE_TIERS}
        seoDesc="Buy premium Dhoop Cones from Prakhyat — 100% natural. Made in Virar, Palghar."
      />
    </>
  );
}